/**
 * "Recently visited pharmacies" — tracked per device/browser via localStorage,
 * deliberately NOT synced to the patient's account (that's what favourites are
 * for, stored server-side in /api/portal/favourites). We only ever store a
 * pharmacy's tenant_id + a timestamp; the display name/logo/colour always
 * come fresh from the already-fetched public directory.
 */
const KEY = 'dutilyne_portal_recent_pharmacies';
// Keep a few more than we display (3) so a recently-visited pharmacy that
// drops out of the live directory (e.g. temporarily suspended) doesn't
// collapse the list to fewer than 3 real options.
const MAX_STORED = 8;

const read = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem(KEY) || '[]');
    return Array.isArray(parsed) ? parsed.filter(id => typeof id === 'string') : [];
  } catch {
    return [];
  }
};

export const recordPharmacyVisit = (tenantId) => {
  if (!tenantId) return;
  try {
    const next = [tenantId, ...read().filter(id => id !== tenantId)].slice(0, MAX_STORED);
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // Private/incognito browsing or storage disabled — recents simply won't persist.
  }
};

/** Most-recently-visited tenant_ids first. */
export const getRecentPharmacyIds = () => read();
